/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */
	/**
	 *
	 * Subscribes to channels: [EcommerceProductDataHub]
	 * Listens to channel events: [startProductDataSubscription, invalidateProductData]
	 * Triggers channel events: []
	 *
	 * @namespace Tc.Module
	 * @class EcommerceProductDataHubTracking
	 * @extends Tc.Module
	 */
	Tc.Module.EcommerceProductDataHubTracking = Tc.Module.extend({

		isInitialTracking: true,
		trackingTimeout: null,
		productChanged: false,
		subscriptionChanged: false,

		lastTracked: null,
		toTrack: null,

		TRACKING_TIMEOUT: 5000,
		// Tealium tag id for metalyzer product retargeting
		TAG_ID_METALYZER_PRODUCT_RETARGETING: 15566,
		PROD_VIEW: 'prodView',
		FAMILY_PAGE: 'familypage',
		EVENT_ACTION_CHANGE: 'change',
		EVENT_LABEL_SUBSCRIPTION_CHANGE: 'subscription selection',
		EVENT_LABEL_PRODUCT_CHANGE: 'product selection',

		on: function (callback) {
			this.onStartProductDataSubscription();
			callback();
		},

		/**
		 * Channel listener to register for EcommerceProductDataHub events.
		 *
		 * @method onStartProductDataSubscription
		 * @return void
		 */
		onStartProductDataSubscription: function () {
			var mod = this,
				initialChannel = 'EcommerceProductDataHub';
			mod.sandbox.subscribe(initialChannel, mod);
			mod.fire('subscribeForProductData', {
				element: mod.$ctx,
				subscribe: function (channel, fetchDataOnSubscribe) {
					if (mod.productDataChannel) {
						mod.sandbox.unsubscribe(mod.productDataChannel, mod);
					}
					mod.productDataChannel = channel;
					mod.sandbox.unsubscribe(initialChannel, mod);
					mod.sandbox.subscribe(channel, mod);

					// If component was lazy loaded, request initialization data
					// from data hub.
					if (fetchDataOnSubscribe) {
						mod.fire('getInfo', {
							callback: function (data) {
								mod.onInvalidateProductData({info: data});
							}
						}, [mod.productDataChannel]);
					}
				}
			}, [initialChannel]);
		},

		after: function () {
		},

		/**
		 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
		 *
		 * @method onInvalidateProductData
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		onInvalidateProductData: function (data) {
			var mod = this;

			if (mod.isProductTeaser()) {
				return;
			}

			if (mod.hasChanged(data)) {

				// abort existing timeout handler
				if (mod.trackingTimeout) {
					clearTimeout(mod.trackingTimeout);
					mod.trackingTimeout = null;
				}

				if (mod.subscriptionChanged) {
					// subscription changed: abort possible product changed flag in addition to the aborted timeout
					mod.productChanged = false;
					mod.track(data);
				} else {

					if (mod.isInitialTracking) {
						// fire initial tracking immediately
						mod.track(data);
					} else {
						// fire subsequent tracking calls with a delay
						mod.trackingTimeout = setTimeout($.proxy(mod.track, mod, data), mod.TRACKING_TIMEOUT);
					}
				}
			}
		},

		/**
		 * Check whether the component is port of a product teaser. In that case the tracking functionality is disabled
		 * @returns {boolean}
		 */
		isProductTeaser: function () {
			var mod = this;
			return mod.$ctx.parents("div.productteaser").length > 0;
		},

		/**
		 * Update data and check whether something has changed
		 */
		hasChanged: function (data) {
			var mod = this;
			mod.productChanged = false;
			mod.subscriptionChanged = false;

			if (mod.isProductTeaser()) {
				return false;
			}

			//if (data.info && data.info.product && data.info.subscriptionId) {
			if (data.info && data.info.product) {
				mod.toTrack = data.info;
				SCS.portal.datalayer.setProduct(
					mod.toTrack.product.getId(),
					mod.toTrack.product.getName(),
					mod.toTrack.product.getName(),
					mod.toTrack.family.getCategory(),
					mod.toTrack.product.getProductCategory2(),
					mod.toTrack.product.getBrand()
				);

				if (mod.isInitialTracking) {
					return true;
				} else {
					mod.productChanged = mod.lastTracked.product.getId() != mod.toTrack.product.getId();
					mod.subscriptionChanged = mod.lastTracked.subscriptionId != mod.toTrack.subscriptionId;
					return mod.productChanged || mod.subscriptionChanged;
				}
			}
			return false;

		},

		track: function (data) {
			var mod = this;

			// due to redundantly fire change events during the initialization need a special case to force the initial tracking
			mod.productChanged = mod.isInitialTracking || mod.productChanged;

			// only track product views if tracking is enabled and when not inside of a product tease
			if (mod.trackingEnabled()) {
				mod.datalayerTracking();
				mod.recommendationsTracking();
				mod.isInitialTracking = false;
				mod.lastTracked = mod.toTrack;
				mod.productChanged = mod.subscriptionChanged = false;
			}
		},

		/**
		 * Tealium tracking
		 */
		datalayerTracking: function () {
			var mod = this;

			if (!SCS.datalayer || !SCS.portal.datalayer) {
				debug.log('Tc.Module.EcommerceProductDataHubTracking.datalayerTracking > SCS.datalayer or SCS.portal.datalayer is not defined. Aborting tealium tracking');
			}

			// handling for first time page load
			if (mod.isInitialTracking) {
				// set currently viewed product
				// debug.log('Tc.Module.EcommerceProductDataHubTracking.datalayerTracking > initial page view tracking');

				SCS.portal.datalayer.trackPageView();
			} else {

				// changed product
				if (mod.productChanged) {

					// in this case we need more than the standard set of information in the event,
					// hence we have to create it manually and cannot use SCS.portal.datalayer.trackEvent() directly
					var interaction = new SCS.portal.datalayer.Interaction()
						.withEvent(
							mod.EVENT_ACTION_CHANGE,
							mod.EVENT_LABEL_PRODUCT_CHANGE,
							mod.FAMILY_PAGE + '-configuration',
							mod.FAMILY_PAGE + '-' + mod.toTrack.family.getFamilyName(),
							mod.EVENT_LABEL_PRODUCT_CHANGE
						).withProduct(SCS.portal.datalayer.getProduct());

					debug.log('Tc.Module.EcommerceProductDataHubTracking.datalayerTracking > product has changed', interaction);
					interaction.track();

					// TAGMAN-515 fire metalyzer tag on product change. Note that tag this only fires
					// on utag.view whereas we normally only fire utag.link on product change
					utag.view(window.utag_data, null, [mod.TAG_ID_METALYZER_PRODUCT_RETARGETING]);

					// changed subscription
				} else if (mod.subscriptionChanged) {
					debug.log('Tc.Module.EcommerceProductDataHubTracking.datalayerTracking > subscription has changed');
					SCS.portal.datalayer.trackEvent(
						mod.EVENT_ACTION_CHANGE,
						mod.EVENT_LABEL_SUBSCRIPTION_CHANGE,
						mod.FAMILY_PAGE + '-' + mod.getSubscriptionName(),
						mod.FAMILY_PAGE + '-' + mod.toTrack.family.getFamilyName()
					);
				} else {
					// case not implemented. either product or subscription should have changed
				}
			}
		},

		getSubscriptionName: function () {
			var mod = this;
			return mod.toTrack.product.getSubscriptions().getName(mod.toTrack.subscriptionId);
		},

		/**
		 * Only allow tracking within the context of the Ecommerce xxx Family Pages
		 */
		trackingEnabled: function () {
			return SCS.portal.datalayer.initialized && /Family Page|Product Detail/i.test(SCS.portal.datalayer.getTemplate());
		},

		/**
		 * Adobe Recommendations tracking
		 */
		recommendationsTracking: function () {
			if (window.mboxDefine && window.mboxUpdate) {
				var mod = this,
					el = $('#productPageMbox'),
					lang = $('html').attr('lang') || 'de',
					product = mod.toTrack.product,
					description = $('meta[name="description"]') ? $('meta[name="description"]').attr('content') : '',
					cleanTitle = mod.$ctx.data('page-title') || '';


				if (el.length > 0) {
					if (mod.isInitialTracking) {
						mboxDefine('productPageMbox', 'global_ProductDetailPage');
					}

					var availability = product.getAvailability();

					availability.load().then(function() {
						adobe.target.getOffer({
							mbox: "global_ProductDetailPage",
							params: {
								id: product.getId() + lang + (mod.toTrack.family.getSegment() ? mod.toTrack.family.getSegment().toUpperCase() : ''),  // (Id + Lang)
								idNoLanguage: product.getId(), // (Id)
								title: cleanTitle,
								name: product.getName(), // (Product Name)
								description: description,
								pageURL: window.location.pathname, // (Page URL)
								thumbnailURL: product.getImageMini(), // (Product Image Mini)
								categoryId: product.getCategory(), //product_categories',  // (Category1, Category2, etc.)
								value: product.getOriginalPrice().value(), //( Original Price)
								valueWithAbo: product.getPrice(mod.toTrack.subscriptionId, mod.toTrack.subscriptionDuration).value(), // (Price with Subscription)
								brand: product.getBrand(), // (Product Brand)
								availability: product.getAvailability().getStatus(), // ( Availability)
								ratings: mod.toTrack.family.getRatings().getSummary().getAverage(), // (Rating)
								language: lang, // (Language)
								cfu: mod.toTrack.family.getSegment(), // (CFU: res or sme)
								ProductImageSmall: product.getImageSmall(), // (Product Image Small)
								ProductImageBig: product.getImageBig(), // (Product Image Big)
								pageType: product_page //page_pagetype' // (Content Type of Page)
							},
							success: function(offer) {
								adobe.target.applyOffer({
									mbox: "global_ProductDetailPage",
									selector: el,
									offer: offer
								});
							},
							error: function(error) {
								console.error(error);
								el.style.visibility = "visible";
							}
						});

					});
				}
			}
		}
	});

})(Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.EcommerceProductDataHubTracking.js
// module id = 248
// module chunks = 0